import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  sportsTypeFieldWrapper: {
    marginTop: 0
  },
  rowWith3Items: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 30
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  fieldInRow: {
    maxWidth: 90
  },
  rowWith2Items: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  subLevelFieldWrapper: {
    marginTop: '0',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  subLevelLabel: {
    fontWeight: 400,
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'pre-line'
  },
  ageFieldWrapper: {
    width: 63
  },
  ageDistributionRow: {
    gap: 3
  },
  activityLevelRow: {
    gap: 14
  },
  imdRow: {
    gap: 14,
    '&:first-of-type': {
      marginBottom: 10
    }
  },
  wellbeingFieldWrapper: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 120
  },
  wellbeingFieldWrapperContent: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 70
  },
  ageActivityHeaderRow: {
    gap: 4,
    marginBottom: 8
  },
  ageActivityRow: {
    gap: 4
  },
  ageGroupFieldWrapper: {
    marginTop: 12,
    '&:first-of-type': {
      marginTop: 0
    }
  }
})

export default useStyles
